import { startEngine } from "./engine.ts";
import { titleScreen } from "./screens/title.ts";

startEngine();
// Canvas text uses the display font, so wait for it before painting cached layers.
void document.fonts.load('40px "Luckiest Guy"').finally(titleScreen);
